import {cx} from '@local/utils/cx'
import SpinnerSVG from '@local/assets/svgs/spinner.svg'

export const Spinner = ({
	className,
	svgClass,
}) => {
	return (
		<div
			role='status'
			className={cx(
				className,
				'pointer-events-none',
			)}>
			<SpinnerSVG
				className={cx(
					'animate-spin',
					'fill-current',
					svgClass,
				)}
				aria-hidden='true' />
			<span className='sr-only'>Loading...</span>
		</div>
	)
}
